import { createElement, type ComponentType, type ReactElement, type SVGProps } from "react"
import {
  BinanceFullIcon, BitmaxIcon,
  BitpinFullIcon,
  BybitFullIcon, ExirIcon, GateIcon, LbankIcon,
  NobitexFullIcon,
  RamzinexFullIcon,
  WallexFullIcon,
} from "@/app/components/UI/Icons"

export type ExchangeFullIcon = ComponentType<SVGProps<SVGSVGElement>>

const exchangeFullIconMap: Record<string, ExchangeFullIcon> = {
  binance: BinanceFullIcon,
  bybit: BybitFullIcon,
  bitpin: BitpinFullIcon,
  nobitex: NobitexFullIcon,
  ramzinex: RamzinexFullIcon,
  wallex: WallexFullIcon,
  gate: GateIcon,
  lbank: LbankIcon,
  exir: ExirIcon,
  bitmax: BitmaxIcon,
}

export const getExchangeFullIcon = (exchange?: string): ExchangeFullIcon | null => {
  if (!exchange) return null
  return exchangeFullIconMap[exchange.toLowerCase()] ?? null
}

export const renderExchangeFullIcon = (
  exchange?: string,
  props?: SVGProps<SVGSVGElement>,
): ReactElement | null => {
  const exchangeFullIcon = getExchangeFullIcon(exchange)

  if (!exchangeFullIcon) return null

  return createElement(exchangeFullIcon, props)
}
